import Layout from '@/pages/layout';
import { RouteObject } from 'react-router-dom';

import Contact from '@/pages/contact';
import FAQ from '@/pages/faq';
import Main from '@/pages/main';
import Terms from '@/pages/terms';

import PurchaseThanks from '@/pages/purchaseThanks';

// Dynamic bootcamp imports
import { Registration as BootcampRegistration } from '@/pages/bootcamp';

// Check-in/out imports
import CheckIn from '@/pages/in/CheckIn';
import Login from '@/pages/login';
import CheckOut from '@/pages/out/CheckOut';
import Dashboard from '@/pages/dashboard';

import Post from '@/pages/post';
import Pre from '@/pages/pre';

import NotFound from '@/pages/NotFound';

export default [
  {
    path: '/',
    element: <Layout />,
    children: [{ index: true, element: <Main /> }],
  },
  {
    path: '/contact',
    element: <Layout />,
    children: [{ index: true, element: <Contact /> }],
  },
  {
    path: '/faq',
    element: <Layout />,
    children: [{ index: true, element: <FAQ /> }],
  },
  {
    path: '/terms',
    element: <Layout />,
    children: [{ index: true, element: <Terms /> }],
  },
  // Check-in/out routes using bootcamp slug
  {
    path: '/bootcamp/:slug/in',
    element: <CheckIn />,
  },
  {
    path: '/bootcamp/:slug/in/login',
    element: <Login />,
  },
  {
    path: '/bootcamp/:slug/out',
    element: <CheckOut />,
  },
  {
    path: '/bootcamp/:slug/out/login',
    element: <Login />,
  },
  {
    path: '/bootcamp/:slug/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/bootcamp/:slug/dashboard/login',
    element: <Login />,
  },
  {
    path: '/purchaseThanks',
    element: <Layout />,
    children: [{ index: true, element: <PurchaseThanks /> }],
  },
  {
    path: '/pre',
    element: <Layout />,
    children: [{ index: true, element: <Pre /> }],
  },
  {
    path: '/post',
    element: <Layout />,
    children: [{ index: true, element: <Post /> }],
  },

  // Dynamic bootcamp routes
  {
    path: '/bootcamp/:slug',
    element: <Layout />,
    children: [{ index: true, element: <BootcampRegistration /> }],
  },

  {
    path: '/*',
    element: <NotFound />,
  },
] as RouteObject[];
